import { GlobalProperty } from '../../constants';
const invokeGlobal = (sb, node, options, property) => {
    sb.emitPushInt(node, 1);
    sb.emitOp(node, 'PACK');
    sb.emitHelper(node, options, sb.helpers.getGlobalProperty({ property }));
    sb.emitHelper(node, options, sb.helpers.invokeCall());
};
export const invokeLogSerialize = (sb, node, options) => invokeGlobal(sb, node, options, GlobalProperty.GenericLogSerialize);

//# sourceMappingURL=serialize.js.map
